//action
import {
    GET_VIEW_CONSULTATION,
    GET_VIEW_CONSULTATION_FAIL,
    GET_VIEW_CONSULTATION_SUCCESS,
    GET_VIEW_CONSULTATION_RESET
} from "../action/getViewConsultation"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_VIEW_CONSULTATION:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_VIEW_CONSULTATION_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_VIEW_CONSULTATION_SUCCESS:
            console.log("resposk", action.response)
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_VIEW_CONSULTATION_RESET:
            return initialState
        default:
            return state
    }
}